export const selectedGroups = (groups: any) => {
  if (!groups) return [];
  return Object.keys(groups)
    .map((groupId) => groups[groupId])
    .filter((groupId) => groupId !== false)
    .map(({ id, name }) => ({ id, name }));
};

export const selectedPermissions = (permissions: any) =>
  Object.keys(permissions)
    .map((permissionId) => permissions[permissionId])
    .filter((permissionId) => permissionId !== false)
    .map(({ id, name }) => ({ id, name }));
